import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["$css", "children"];
import React from 'react';
import { css } from 'styled-components';
import { COLORS, TYPOGRAPHY } from '../../../themes';
import LinkOrButton from '../../LinkOrButton';
import { focus, hover } from '../../../styling';

var HLink = function HLink(_ref) {
  var $css = _ref.$css,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(LinkOrButton, _extends({
    $css: css(["", ";text-decoration:underline;border-radius:4px;", " ", ";", ""], TYPOGRAPHY.M, focus(css(["color:", ";box-shadow:0 0 0 1px ", ";outline:1px solid transparent;"], COLORS.PRIMARY_600, COLORS.PRIMARY_600)), hover('color', COLORS.PRIMARY_500, COLORS.PRIMARY_700), $css)
  }, props), children);
};

export default HLink;